
import { MouseEvent } from "react"
import { ReactComponent as CloseIcon } from '../../assets/Icons/adornments/Close.svg';
import { ReactComponent as CollapseIcon } from '../../assets/Icons/chevron/Double-Chevron-Right.svg';
export default function PopupHeader({
    label,
    hasOutline,
    closeFn,
    collapseFn,
}: {
    label: string,
    hasOutline: boolean,
    closeFn?: (e: MouseEvent<HTMLButtonElement>) => void,
    collapseFn?: (e: MouseEvent<HTMLButtonElement>) => void,
}) {
    return (
        <div className={`w-full p-6 flex justify-between items-center gap-3 border-light-outline ${hasOutline ? 'border-b' : 'border-none'}`}>
            <p className="font-semibold text-default text-[20px]">{label}</p>
            <button onClick={closeFn ? closeFn : collapseFn ? collapseFn : () => {}} className="text-disable hover:text-primary transition-all">
                {closeFn ? (
                    <div className="w-[18px] h-[18px]"><CloseIcon/></div>
                ) : (
                    <div className="w-[18px] h-[18px]"><CollapseIcon/></div>
                )}
            </button>
        </div>
    )
}